import { commonFilter } from './filter';

export default {
  pageName: 'Compare-SameStartDate',
  pageId: '25020',
  pagePath: '/opinion/Compare',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    ...commonFilter,
    SelectGame: {
      buttonId: '25020101',
    },
    ConfirmGameSelection: {
      buttonId: '25020102',
    },
    DateTypeSwitch: {
      buttonId: '25020103',
    },
    ClickOneMetricsSet: {
      buttonId: '25020105',
    },
    EditMetrics: {
      buttonId: '25020106',
    },
    ConfirmEditedMetrics: {
      buttonId: '25020107',
    },

    SplitMetrics: {
      buttonId: '25020108',
    },
    Rank: {
      buttonId: '25020109',
    },
    Locate: {
      buttonId: '25020110',
    },
    DeleteGame: {
      buttonId: '25020110',
    },
  },
  card: {
    'Game Comparison Table': {
      download: {
        buttonId: '25020111',
      },
    },
    'Comparison Chart': {
      line: {
        buttonId: '25020112',
      },
      bar: {
        buttonId: '25020113',
      },
      download: {
        buttonId: '25020114',
      },
    },
  },
};
